var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartBarDonut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 32,
    viewBox: "0 0 39 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.18 6.93359C18.73 6.93359 13.5 12.1636 13.5 18.6136C13.5 25.0636 18.73 30.2936 25.18 30.2936C31.63 30.2936 36.86 25.0636 36.86 18.6136H25.18V6.93359Z",
    stroke: "white",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9604 5.71484C33.0604 5.71484 38.0004 10.6549 38.0004 16.7549C32.9604 16.7549 26.9604 16.8248 26.9604 16.8248V5.71484Z",
    stroke: "white",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9604 10.7649V1.29492H11.2104V30.7049H14.9604V26.4449",
    stroke: "white",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8501 6.06445H6.1001V30.7045H9.8501V6.06445Z",
    stroke: "white",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 11.5352H1V30.6951H4.75V11.5352Z",
    stroke: "white",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBarDonut);
export default __webpack_public_path__ + "static/media/chart-bar-donut.f7f63f21cde856f7f414f96da9abf9c7.svg";
export { ForwardRef as ReactComponent };